import { defineComponent as _defineComponent } from 'vue'
import { withDefaults } from "vue";
import AppModal from "@/components/AppModal.vue";
import WeProposeApp from "@/components/WeProposeApp.vue";
import { useMigrateBanner } from "@/composables/useMigrateBanner";


export default /*#__PURE__*/_defineComponent({
  __name: 'WeProposeOurAppModal',
  props: {
    isOpen: { type: Boolean, default: false }
  },
  emits: ["close", "submit"],
  setup(__props: any, { expose, emit: emits }) {
  expose();

const props = __props as { isOpen: boolean }



const { isMigratedToApp } = useMigrateBanner();

const close = () => {
  emits("close");
};

const __returned__ = { emits, props, isMigratedToApp, close, withDefaults, AppModal, WeProposeApp, useMigrateBanner }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})